import { injectable } from "inversify";

import * as Api from "../constants/ApiUrlConstants";
import IoCContainer from '../wires/Bootstrapper';
import { IApiService } from "./shared/ApiService";
import { IApiServiceExt } from "./shared/ApiServiceExt";
import SERVICE_IDENTIFIER from "../wires/Identifiers";
import { SearcherBaseModel } from "../models/SearcherBaseModel";
import { ProjectionPagedModel } from "../models/ProjectionPageModel";
import { ModelBase } from "../models/ModelBase";
import { ClienteModel } from "../models/ClienteModels";
import { AssegnaLicenzaClientiInput, LicenzaClientiModel } from "../models/Licenza";

export interface ILicenzaClientiService {
    Render(idLicenza: string): Promise<LicenzaClientiModel>
    Search(search: SearcherBaseModel): Promise<ProjectionPagedModel<ClienteModel>>
    AssegnaClienti(idLicenza: string, idClienti: Array<string>): Promise<ModelBase>
}

@injectable()
export class LicenzaClientiService implements ILicenzaClientiService {

    RenderApi = Api.RenderLicenzaClienti
    apiService: IApiService
    apiServiceExt: IApiServiceExt

    constructor() {
        this.apiService = IoCContainer.get(SERVICE_IDENTIFIER.API_SERVICE);
        this.apiServiceExt = IoCContainer.get(SERVICE_IDENTIFIER.API_SERVICE_EXT);
    }


    async Render(idLicenza: string): Promise<LicenzaClientiModel> {
        return await this.apiService.getAsync<LicenzaClientiModel>(Api.RenderLicenzaClienti, { Id: idLicenza });
    }

    async Search(search: SearcherBaseModel): Promise<ProjectionPagedModel<ClienteModel>> {
        return await this.apiService.postAsync<ProjectionPagedModel<ClienteModel>>(Api.LicenzaCercaClienti, search);
    }

    async AssegnaClienti(IdLicenza: string, IdClienti: Array<string>): Promise<ModelBase> {
        let data: AssegnaLicenzaClientiInput = { IdClienti, IdLicenza }
        return await this.apiServiceExt.postAsync<ModelBase>(Api.AssegnaLicenzaClienti, data);
    } 
}